import translate from 'angular-translate';
import translateLoaderPluggable from 'angular-translate-loader-pluggable';
import 'angular-translate-loader-partial';
import 'angular-translate-interpolation-messageformat';
import { translationConfig } from './translation.config';
import { translationRun } from './translation.run';

export default angular
  .module('ng1-translation', [
    translate,
    translateLoaderPluggable.name
  ])
  .config(translationConfig)
  .run(translationRun)
  .name;



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-translation/src/index.js